import React from "react"
import withStyles from "@material-ui/core/styles/withStyles"
import classnames from "classnames"

import { Link } from "react-router-dom"

import Drawer from "@material-ui/core/Drawer"
import Divider from "@material-ui/core/Divider"
import { Caption } from "ui-Text"

import ScrollFrame, { ScrollFrameBody, ScrollFrameFooter } from "ui-ScrollFrame"
import List, { ListItem, ListItemText } from "ui-List"
import ListSubheader from "@material-ui/core/ListSubheader"

const styleSheet = theme => ({
  paper: {
    maxWidth: "90vw",
    width: theme.spacing.unit * 32,
    height: "100%",
  },

  footer: {
    padding: theme.spacing.unit * 2,

    "& a": {
      textDecoration: "none",

      "& +a": {
        marginLeft: theme.spacing.unit * 2,
      },
    },
  },
})

class MainAppDrawer extends React.Component {
  render() {
    const {
      classes,
      className: classNameProp,

      ...otherProps
    } = this.props

    const className = classnames(classes.root, classNameProp)

    return (
      <Drawer
        className={className}
        classes={{ paper: classes.paper }}
        anchor="right"
        {...otherProps}
      >
        <ScrollFrame>
          <ScrollFrameBody>
            <List>
              <ListItem button to="/" component={Link}>
                <ListItemText primary="Home" />
              </ListItem>
            </List>
            <List subheader={<ListSubheader>Services</ListSubheader>}>
              <ListItem button to="/breastfeeding-support/in-home-consultation" component={Link}>
                <ListItemText primary="In Home Consultation" />
              </ListItem>
              <ListItem button to="/breastfeeding-support/prenatal-consultation" component={Link}>
                <ListItemText primary="Prenatal Consultation" />
              </ListItem>
              <ListItem button to="/breastfeeding-support/weight-check" component={Link}>
                <ListItemText primary="Weight Check" />
              </ListItem>
            </List>
            <List subheader={<ListSubheader>More Links</ListSubheader>}>
              <ListItem button to="/forms" component={Link}>
                <ListItemText primary="Forms" />
              </ListItem>
              <ListItem button to="/contact" component={Link}>
                <ListItemText primary="Contact" />
              </ListItem>
            </List>
          </ScrollFrameBody>
          <Divider />
          <ScrollFrameFooter className={classes.footer}>
            <Caption paragraph>
              &copy; 2017-{new Date().getFullYear()} Julie Alexander Lactation Support, LLC
            </Caption>
            <Caption>
              <Link to="/terms">Terms</Link>
              <Link to="/privacy">Privacy</Link>
            </Caption>
          </ScrollFrameFooter>
        </ScrollFrame>
      </Drawer>
    )
  }
}

export default withStyles(styleSheet)(MainAppDrawer)



// WEBPACK FOOTER //
// ./src/views/chrome/MainAppDrawer/MainAppDrawer.js